<template>
    <div class="skiptranslate" id="recaptcha-validate" v-bind:data-sitekey="recaptchaKey">Please wait...</div>
</template>

<script>
    import RecaptchaDetectDebugMixin from '../mixins/RecaptchaDetectDebugMixin'
    export default {
        mixins: [RecaptchaDetectDebugMixin],
        data() {
            return {
                csoEnabled: localStorage.csoEnabled
            }
        },
        mounted() {
            if (this.csoEnabled === 'false') {
                // Delay a bit so we can make sure that the required global object does exists
                setTimeout(() => {
                    if (grecaptcha && grecaptcha.hasOwnProperty('render')) {
                        const RECAPTCHA_WIDGET_ID = grecaptcha.render('recaptcha-validate', {
                            callback: this.onChange,
                            'expired-callback': this.onChange
                        });
                        this.$emit('onChange', RECAPTCHA_WIDGET_ID);
                    }
                }, 1000);
            }
        },
        methods: {
            onChange(e) {
                this.$emit('onChange', e);
            }
        },
        computed: {
            recaptchaKey() {
                return process.env.MIX_RECAPTCHA_SITE_KEY;
            }
        },
    }
</script>
